module.exports = __webpack_public_path__ + "img/plus.cee1fb53.svg";